














import { inject } from 'inversify-props';
import { Vue, Prop, Component } from 'vue-property-decorator';
import IAuthService from '../../../services/IAuthService';
import { InputValidation } from '../../../helpers/inputValidation';
import { IFormat, Format, FORMAT_VALIDATION_RULES } from '@models';
import FormatsBase from '../../FormatsBase';

@Component
export default class FormatSelector extends FormatsBase {
  name = 'format-selector';

  // Enabling the use of v-model where this custom component is used
  @Prop(String) value: string;
  updateValue(value: Format) {
    this.$emit('input', value)
  }
  @Prop(String) selected: string;

  get validationRules() {
    return [...FORMAT_VALIDATION_RULES.formatid, this.isFormatIdTaken];
  }

  isFormatIdTaken(formatId: string): boolean | string {
    let existingFormat = null;

    if (formatId) {
      existingFormat = this.formats.find(x => x.id.toLocaleLowerCase() == formatId.toLocaleLowerCase());
    }
    return !!!existingFormat || "FormatId is already taken. Please choose another";
  }

  isValidFormatId(evt: Event) {
    if (InputValidation.onlyUrlFriendlyCharsRegEx.test(evt.key)) evt.preventDefault();
  }

  created() {
    this.init();
  }

  get getSelectedFormat() {
    if (!this.selected) {
      let existingFormat = null;
      existingFormat = this.formats.find(x => x.id.toLocaleLowerCase() == this.selected.toLocaleLowerCase());
    }
    return null;
  }

}
